import Typography from "../Pages/UiKit/Typography";
import Avatars from "../Pages/UiKit/Avatars";
import TagAndPills from "../Pages/UiKit/TagAndPills";
import Progress from "../Pages/UiKit/ProgressBar";
import HelperClasses from "../Pages/UiKit/HelperClasses";
import Grid from "../Pages/UiKit/Grid";
import Tabs from "../Pages/UiKit/Tabs";
import Dropdown from "../Pages/UiKit/Dropdown";
import Accordion from "../Pages/UiKit/Accordion";
import Alert from "../Pages/UiKit/Alert";
import Popover from "../Pages/UiKit/Popover";
import Tooltip from "../Pages/UiKit/Tooltip";
import Modal from "../Pages/UiKit/Modal";
import FlagIcons from "../Pages/Icons/FlagIcons";
import FontawesomeIcon from "../Pages/Icons/FontawesomeIcon";
import IcoIcons from "../Pages/Icons/IcoIcons";
import ThemifyIcon from "../Pages/Icons/ThemifyIcon";
import FeatherIcons from "../Pages/Icons/FeatherIcons";
import WhetherIcon from "../Pages/Icons/WhetherIcon";
import Lists from "../Pages/UiKit/Lists";
import DefaultStyle from "../Pages/Buttons/DefaultStyle";
import FlatStyle from "../Pages/Buttons/FlatStyle";
import Scrollable from "../Pages/BonusUi/Scrollable";
import TreeView from "../Pages/BonusUi/Tree View";
import Toasts from "../Pages/BonusUi/Toasts";
import Rating from "../Pages/BonusUi/Rating";
import Dropzone from "../Pages/BonusUi/Dropzone";
import Tour from "../Pages/BonusUi/Tour";
import LearningList from "../Pages/Learning/LearningList";
import DetailedCourse from "../Pages/Learning/DetailedCourse";
import BasicDataTables from "../Pages/DataTable/BasicDataTables";
import AdvanceInit from "../Pages/DataTable/AdvanceInit";
import ApiDataTables from "../Pages/DataTable/ApiDataTables";
import DataSource from "../Pages/DataTable/DataSource";
import BasicTables from "../Pages/BootstrapTables/BasicTables";
import TableComponents from "../Pages/BootstrapTables/TableComponents";
import FormValidation from "../Pages/FormControl/FormValidation";
import BaseInputs from "../Pages/FormControl/BaseInputs";
import CheckboxRadio from "../Pages/FormControl/CheckboxRadio";
import InputGroups from "../Pages/FormControl/InputGroups";
import MegaOptions from "../Pages/FormControl/MegaOptions";
import CardsView from "../Pages/JobSearch/CardsView";
import ListView from "../Pages/JobSearch/ListView";
import JobDetails from "../Pages/JobSearch/JobDetails";
import JobApply from "../Pages/JobSearch/JobApply";
import Datepicker from "../Pages/FormWidgets/Datepicker";
import Touchspin from "../Pages/FormWidgets/Touchspin";
import Switch from "../Pages/FormWidgets/Switch";
import Typeahead from "../Pages/FormWidgets/Typeahead";
import Clipboard from "../Pages/FormWidgets/Clipboard";
import Ribbons from "../Pages/BonusUi/Ribbons";
import Paginations from "../Pages/BonusUi/Paginations";
import Breadcrumbs from "../Pages/BonusUi/Breadcrumb";
import ButtonGroup from "../Pages/Buttons/ButtonGroup";
import BasicCard from "../Pages/BonusUi/BasicCard";
import CreativeCard from "../Pages/BonusUi/CreativeCard";
import Timeline from "../Pages/BonusUi/Timeline";
import SweetAlerts from "../Pages/BonusUi/SweetAlerts";
import Carousel from "../Pages/BonusUi/Carousel";
import RaisedStyle from "../Pages/Buttons/RaisedStyle";
import EdgeStyle from "../Pages/Buttons/EdgeStyle";
import RangeSlider from "../Pages/BonusUi/RangeSlider";
import ImageCropper from "../Pages/BonusUi/ImageCropper";
import ApexChart from "../Pages/Charts/ApexChart";
import GoogleChart from "../Pages/Charts/GoogleChart";
import ChartJS from "../Pages/Charts/ChartJS";
import GalleryGrid from "../Pages/Gallery/GalleryGrid";
import GalleryGridWithDescription from "../Pages/Gallery/GalleryGridWithDescription";
import MasonryGallery from "../Pages/Gallery/MasonryGallery";
import MasonryGalleryWithDescription from "../Pages/Gallery/MasonryGalleryWithDescription";
import ImageHoverEffects from "../Pages/Gallery/ImageHoverEffects";
import BlogDetails from "../Pages/Blog/BlogDetails";
import BlogSingle from "../Pages/Blog/BlogSingle";
import AddPost from "../Pages/Blog/AddPost";
import Faq from "../Pages/FAQ/Faq";
import CkEditors from "../Pages/Editors/CkEditors";
import SimpleMdeEditors from "../Pages/Editors/SimpleMdeEditors";
import AceCodeEditors from "../Pages/Editors/AceCodeEditors";
import Knowledgebase from "../Pages/Knowledgebase/Knowledgebase";
import SupportTicket from "../Pages/SupportTicket/SupportTicket";
import GoogleMap from "../Pages/Maps/GoogleMap";
import LeafletMap from "../Pages/Maps/LeafletMap";
import DefaultWidget from "../Pages/Widgets/DefaultWidget";
import ChartWidget from "../Pages/Widgets/ChartWidget";
import DefaultDashboard from "../Pages/Dashboard/DefaultDashboard";
import EcommerceDashboard from "../Pages/Dashboard/EcommerceDashboard";
import ProjectList from "../Pages/Project/ProjectList";
import CreateProject from "../Pages/Project/CreateProject";
import FileManager from "../Pages/FileManager/FileManager";
import HideNavScroll from "../Pages/PageLayout/HideNavScroll";
import FooterDark from "../Pages/PageLayout/FooterDark";
import FooterFixed from "../Pages/PageLayout/FooterFixed";
import Product from "../Pages/Ecommerce/Product";
import ProductPage from "../Pages/Ecommerce/ProductPage";
import ProductList from "../Pages/Ecommerce/ProductList";
import PaymentDetails from "../Pages/Ecommerce/PaymentDetails";
import OrderHistory from "../Pages/Ecommerce/OrderHistory";
import Invoice from "../Pages/Ecommerce/Invoice";
import Cart from "../Pages/Ecommerce/Cart";
import WhishList from "../Pages/Ecommerce/WhishList";
import CheckOut from "../Pages/Ecommerce/CheckOut";
import Pricing from "../Pages/Ecommerce/Pricing";
import ToDo from "../Pages/ToDo/ToDo";
import SearchResult from "../Pages/SearchResualt/SearchResult";
import Task from "../Pages/Task/Task";
import Calendar from "../Pages/Calendar/Calender";
import SocialApp from "../Pages/SocialApp/SocialApp";
import EmailApplication from "../Pages/Email/EmailApplication";
import EmailCompose from "../Pages/Email/EmailCompose";
import Contacts from "../Pages/Contacts/contacts";
import ChatApp from "../Pages/Chat/ChatApp";
import VideoChat from "../Pages/Chat/VideoChat";
import UserProfile from "../Pages/Users/UserProfile";
import EditProfile from "../Pages/Users/EditProfile";
import UserCard from "../Pages/Users/UserCard";
import FormWizardOne from "../Pages/FormLayout/FormWizardOne";
import FormWizardTwo from "../Pages/FormLayout/FormWizardTwo";
import TwoFactor from "../Pages/FormLayout/TwoFactor";
import Bookmark from "../Pages/Bookmarks/Bookmark";
import SamplePage from "../Pages/SamplePage/SamplePage";

export const ROUTES = [
  //UI Kits
  { path: `${process.env.PUBLIC_URL}/ui-kits/typography`, element: <Typography /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/avatars`, element: <Avatars /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tag-pills`, element: <TagAndPills /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/progress-bar`, element: <Progress /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/helper-classes`, element: <HelperClasses /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/grid`, element: <Grid /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tabs`, element: <Tabs /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/dropdown`, element: <Dropdown /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/accordion`, element: <Accordion /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/alert`, element: <Alert /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/popover`, element: <Popover /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tooltip`, element: <Tooltip /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/modal-bar`, element: <Modal /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/lists`, element: <Lists /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/modal-bar`, element: <Modal /> },

  //Buttons
  { path: `${process.env.PUBLIC_URL}/buttons/buttons`, element: <DefaultStyle /> },
  { path: `${process.env.PUBLIC_URL}/buttons/flate-style`, element: <FlatStyle /> },

  //Learning
  { path: `${process.env.PUBLIC_URL}/learning/learning-list-view`, element: <LearningList /> },
  { path: `${process.env.PUBLIC_URL}/learning/learning-detail`, element: <DetailedCourse /> },

  //Data Table
  { path: `${process.env.PUBLIC_URL}/form/data-tables/basic-init`, element: <BasicDataTables /> },
  { path: `${process.env.PUBLIC_URL}/form/data-tables/advance-init`, element: <AdvanceInit /> },
  { path: `${process.env.PUBLIC_URL}/form/data-tables/api`, element: <ApiDataTables /> },
  { path: `${process.env.PUBLIC_URL}/form/data-tables/data-sources`, element: <DataSource /> },

  //Bootstrap Table
  { path: `${process.env.PUBLIC_URL}/form/bootstrap-tables/basic-table`, element: <BasicTables /> },
  { path: `${process.env.PUBLIC_URL}/form/bootstrap-tables/table-componants`, element: <TableComponents /> },

  //Form Control
  { path: `${process.env.PUBLIC_URL}/form-controls/form-validation`, element: <FormValidation /> },
  { path: `${process.env.PUBLIC_URL}/form-controls/base-input`, element: <BaseInputs /> },
  { path: `${process.env.PUBLIC_URL}/form-controls/radio-checkbox-control`, element: <CheckboxRadio /> },
  { path: `${process.env.PUBLIC_URL}/form-controls/input-group`, element: <InputGroups /> },
  { path: `${process.env.PUBLIC_URL}/form-controls/mega-options`, element: <MegaOptions /> },

  //Job Search
  { path: `${process.env.PUBLIC_URL}/job-search/job-cards-view`, element: <CardsView /> },
  { path: `${process.env.PUBLIC_URL}/job-search/job-list-view`, element: <ListView /> },
  { path: `${process.env.PUBLIC_URL}/job-search/job-details`, element: <JobDetails /> },
  { path: `${process.env.PUBLIC_URL}/job-search/job-apply`, element: <JobApply /> },

  //Form Widgets
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/datepicker`, element: <Datepicker /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/touch-spin`, element: <Touchspin /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/switch`, element: <Switch /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/typeahead`, element: <Typeahead /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-widgets/clipboard`, element: <Clipboard /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/ribbons`, element: <Ribbons /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/pagination`, element: <Paginations /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/breadcrumb`, element: <Breadcrumbs /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/sweet-alert-2`, element: <SweetAlerts /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/range-slider`, element: <RangeSlider /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/image-cropper`, element: <ImageCropper /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/modal-bar`, element: <Modal /> },

  //Icons
  { path: `${process.env.PUBLIC_URL}icons/flag-icon`, element: <FlagIcons /> },
  { path: `${process.env.PUBLIC_URL}/icons/font-awesome`, element: <FontawesomeIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/ico-icon`, element: <IcoIcons /> },
  { path: `${process.env.PUBLIC_URL}/icons/themify-icon`, element: <ThemifyIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/feather-icon`, element: <FeatherIcons /> },
  { path: `${process.env.PUBLIC_URL}/icons/whether-icon`, element: <WhetherIcon /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/modal-bar`, element: <Modal /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/lists`, element: <Lists /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/modal-bar`, element: <Modal /> },

  //Buttons
  { path: `${process.env.PUBLIC_URL}/buttons/buttons`, element: <DefaultStyle /> },
  { path: `${process.env.PUBLIC_URL}/buttons/flate-style`, element: <FlatStyle /> },
  { path: `${process.env.PUBLIC_URL}/buttons/button-group`, element: <ButtonGroup /> },
  { path: `${process.env.PUBLIC_URL}/buttons/buttons`, element: <DefaultStyle /> },
  { path: `${process.env.PUBLIC_URL}/buttons/flate-style`, element: <FlatStyle /> },
  { path: `${process.env.PUBLIC_URL}/buttons/edge-style`, element: <EdgeStyle /> },
  { path: `${process.env.PUBLIC_URL}/buttons/raised-style`, element: <RaisedStyle /> },

  //Bonus UI
  { path: `${process.env.PUBLIC_URL}/bonus-ui/dropzone`, element: <Dropzone /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/tour`, element: <Tour /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/scrollable`, element: <Scrollable /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/tree`, element: <TreeView /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/toasts`, element: <Toasts /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/rating`, element: <Rating /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/basic-card`, element: <BasicCard /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/creative-card`, element: <CreativeCard /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/timeline`, element: <Timeline /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/sweet-alert-2`, element: <SweetAlerts /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/carousel`, element: <Carousel /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/range-slider`, element: <RangeSlider /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/image-cropper`, element: <ImageCropper /> },

  //Charts
  { path: `${process.env.PUBLIC_URL}/charts/chart-apex`, element: <ApexChart /> },
  { path: `${process.env.PUBLIC_URL}/charts/chart-google`, element: <GoogleChart /> },
  { path: `${process.env.PUBLIC_URL}/charts/chartjs`, element: <ChartJS /> },

  //Miscellaneous - Gallery
  { path: `${process.env.PUBLIC_URL}/gallery/gallery`, element: <GalleryGrid /> },
  { path: `${process.env.PUBLIC_URL}/gallery/gallery-with-description`, element: <GalleryGridWithDescription /> },
  { path: `${process.env.PUBLIC_URL}/gallery/gallery-masonry`, element: <MasonryGallery /> },
  { path: `${process.env.PUBLIC_URL}/gallery/masonry-gallery-with-disc`, element: <MasonryGalleryWithDescription /> },
  { path: `${process.env.PUBLIC_URL}/gallery/gallery-hover`, element: <ImageHoverEffects /> },

  //Miscellaneous - Blog
  { path: `${process.env.PUBLIC_URL}/blog/blog-detail`, element: <BlogDetails /> },
  { path: `${process.env.PUBLIC_URL}/blog/blog-single`, element: <BlogSingle /> },
  { path: `${process.env.PUBLIC_URL}/blog/add-post`, element: <AddPost /> },

  //FAQ
  { path: `${process.env.PUBLIC_URL}/faq`, element: <Faq /> },

  //Editors
  { path: `${process.env.PUBLIC_URL}/editors/ck-editor`, element: <CkEditors /> },
  { path: `${process.env.PUBLIC_URL}/editors/simple-MDE`, element: <SimpleMdeEditors /> },
  { path: `${process.env.PUBLIC_URL}/editors/acecode-editor`, element: <AceCodeEditors /> },

  //Knowledgebase
  { path: `${process.env.PUBLIC_URL}/knowledgebase/knowledgebase`, element: <Knowledgebase /> },

  //Support Ticket
  { path: `${process.env.PUBLIC_URL}/support-ticket`, element: <SupportTicket /> },

  //Maps
  { path: `${process.env.PUBLIC_URL}/maps/google-map`, element: <GoogleMap /> },
  { path: `${process.env.PUBLIC_URL}/maps/leaflet-map`, element: <LeafletMap /> },

  //Widget
  { path: `${process.env.PUBLIC_URL}/widgets/general-widget`, element: <DefaultWidget /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart-widget`, element: <ChartWidget /> },

  //Dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, element: <DefaultDashboard /> },
  { path: `${process.env.PUBLIC_URL}/dashboards/ecommerce`, element: <EcommerceDashboard /> },

  //Project
  { path: `${process.env.PUBLIC_URL}/project/project-list`, element: <ProjectList /> },
  { path: `${process.env.PUBLIC_URL}/project/create-project`, element: <CreateProject /> },

  //File manager
  { path: `${process.env.PUBLIC_URL}/file-manager`, element: <FileManager /> },

  //Page Layout
  { path: `${process.env.PUBLIC_URL}/page-layout/hide-nav-scroll`, element: <HideNavScroll /> },
  { path: `${process.env.PUBLIC_URL}/page-layout/footer-dark`, element: <FooterDark /> },
  { path: `${process.env.PUBLIC_URL}/page-layout/footer-fixed`, element: <FooterFixed /> },

  //Ecommerce
  { path: `${process.env.PUBLIC_URL}/ecommerce/product`, element: <Product /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/product-page`, element: <ProductPage /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/product-list`, element: <ProductList /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/payment-details`, element: <PaymentDetails /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/order-history`, element: <OrderHistory /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/invoice`, element: <Invoice /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/cart`, element: <Cart /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/wishlist`, element: <WhishList /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/checkout`, element: <CheckOut /> },
  { path: `${process.env.PUBLIC_URL}/ecommerce/pricing`, element: <Pricing /> },

  //To DO
  { path: `${process.env.PUBLIC_URL}/to-do`, element: <ToDo /> },

  //Search Result
  { path: `${process.env.PUBLIC_URL}/search`, element: <SearchResult /> },

  //Task
  { path: `${process.env.PUBLIC_URL}/task`, element: <Task /> },

  //Calender
  { path: `${process.env.PUBLIC_URL}/calendar-basic`, element: <Calendar /> },

  //Social App
  { path: `${process.env.PUBLIC_URL}/social-app`, element: <SocialApp /> },

  //Email
  { path: `${process.env.PUBLIC_URL}/email/email-app`, element: <EmailApplication /> },
  { path: `${process.env.PUBLIC_URL}/email/email-compose`, element: <EmailCompose /> },

  //Contact
  { path: `${process.env.PUBLIC_URL}/contacts`, element: <Contacts /> },

  //Chat
  { path: `${process.env.PUBLIC_URL}/chat/chat`, element: <ChatApp /> },
  { path: `${process.env.PUBLIC_URL}/chat/chat-video`, element: <VideoChat /> },

  //Users
  { path: `${process.env.PUBLIC_URL}/users/user-profile`, element: <UserProfile /> },
  { path: `${process.env.PUBLIC_URL}/users/edit-profile`, element: <EditProfile /> },
  { path: `${process.env.PUBLIC_URL}/users/user-cards`, element: <UserCard /> },

  //Form Layout
  { path: `${process.env.PUBLIC_URL}/forms/form-layout/form-wizard-1`, element: <FormWizardOne /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-layout/form-wizard-2`, element: <FormWizardTwo /> },
  { path: `${process.env.PUBLIC_URL}/forms/form-layout/two-factor`, element: <TwoFactor /> },

  //Bookmarks
  { path: `${process.env.PUBLIC_URL}/bookmark`, element: <Bookmark /> },

  //Page
  { path: `${process.env.PUBLIC_URL}/pages/sample-page`, element: <SamplePage /> },
];
